import { ActionTree, ActionContext } from 'vuex';
import { computed } from 'vue';
import { RootState, useStore } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { AuthActionTypes } from "./action-types";
import { UserLogged } from "@/models/auth/user-logged.model";
import { AuthMutationTypes } from "./mutation-types";
import { Buffer } from 'buffer';
import { useOidcStore } from "vue3-oidc";
import * as CryptoJS from 'crypto-js';
import { MenuMutationTypes } from '../menu/mutation-types';
import { MenuActionTypes } from '../menu/action-types';

const { state } = useOidcStore();
const userManager = computed(() => state.value.userManager);

type AugmentedActionContext = {
    commit<K extends keyof Mutations>(
        key: K,
        payload: Parameters<Mutations[K]>[1],
    ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
    [AuthActionTypes.ACTION_LOGOUT](
        { commit }: AugmentedActionContext,
        user: UserLogged
    ): void,
    [AuthActionTypes.ACTION_LOGIN_LEGACY](
        { commit }: AugmentedActionContext,
        jwtToken: string
    ): Promise<any>,
    [AuthActionTypes.ACTION_LOGOUT_LEGACY](
        { commit }: AugmentedActionContext
    ): void
}

export const actions: ActionTree<State, RootState> & Actions = {
    [AuthActionTypes.ACTION_LOGOUT]({ commit }, user: UserLogged) {
        //authService.logout();
        commit(AuthMutationTypes.LOGOUT, user);
        userManager.value?.signoutRedirect();
    },
    [AuthActionTypes.ACTION_LOGOUT_LEGACY]({ commit }) {
        sessionStorage.clear();
        localStorage.clear();
    },
    async [AuthActionTypes.ACTION_LOGIN_LEGACY]({ commit }, jwtToken: string): Promise<any> {
        const user = parseJwt(jwtToken);
        sessionStorage.setItem("isLegacy", "1");
        sessionStorage.setItem("tokenLegacy", jwtToken);

        /*
        const permissions = await usuarioService.getPermissoesSegUsuario(user.codigoUsuario);
        const permissionsEncrypted = CryptoJS.AES.encrypt(JSON.stringify(permissions), process.env.KEY as string).toString();
        const grupoUsuarioIdEncrypted = CryptoJS.AES.encrypt(user.codigoGrupoUsuario.toString(), process.env.KEY as string).toString();
        commit(AuthMutationTypes.LOGIN_SUCCESS, { segUsuarioId: user.codigoUsuario, code: permissionsEncrypted, grupoUsuario: grupoUsuarioIdEncrypted });
        if (!localStorage.getItem('ultimaObraSelecionada')) {
            return usuarioService.getObrasAcessoUsuario().then((request) => {
                useStore().dispatch(MenuActionTypes.ACTION_SET_OBRA, request.data[0]);
            });

        }
        return Promise.resolve();
        */
        return Promise.resolve();

    },
};


function parseJwt(token: string) {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
}

